export default __webpack_public_path__ + "static/media/new-text-active.03918efa.svg";